import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {SelectorContainer} from '../../core/definitions/selector-container';
import {SearchSelectorService} from '../../core/search-selector.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {BaseModel} from '../../core/definitions/base-model';
import {SearchExecutorService} from '../search-executor.service';
import {SearchContainer} from '../../core/definitions/search-container';

@Component({
    selector: 'app-search-view-selector',
    templateUrl: './search-view-selector.component.html',
    styleUrls: ['./search-view-selector.component.scss'],
    animations: [
        trigger('slideSelector', [
            transition(':leave', [
                style({ overflow: 'hidden' }),
                animate('200ms ease-in', style({ transform: 'translateX(100%)' }))
            ]),
            transition(':enter', [
                style({ overflow: 'hidden', transform: 'translateX(100%)' }),
                animate('200ms ease-out', style({ transform: 'translateX(0%)' }))
            ])
        ])
    ],
    standalone: false
})
export class SearchViewSelectorComponent implements OnInit {
  // Injections
  private readonly searchExecutorService: SearchExecutorService = inject(SearchExecutorService);
  private readonly searchSelectorService: SearchSelectorService = inject(SearchSelectorService);

  @Input() selectorContainer: SelectorContainer;
  @Input() modalIsOpen: boolean;
  @Input() stylingClass: string;

  @Output() modalClosed = new EventEmitter();

  setSearchQueryFocus = true;
  newLayout = false;
  searchPlaceholder = 'TRANS__HEADER__SEARCH_PLACEHOLDER';
  searchContainer: SearchContainer;
  nameObject: BaseModel;

  private _headlineText: string | null = null;

  get headlineText(): string | null {
    return this._headlineText;
  }

  ngOnInit() {
    console.log(this.selectorContainer.searchContainer);
    this.searchContainer = this.selectorContainer.searchContainer;
    if (this.searchContainer.selections.originalItems.length) {
      this.nameObject = new BaseModel(this.searchContainer.selections.originalItems[0].artifact_id);
    }

    this._updateHeadlineText();
    this.searchExecutorService.runSearch(this.searchContainer).then();
  }

  private _updateHeadlineText(): void {
    const viewName = this.searchContainer?.searchView?.view_name;
    switch (viewName) {
      case 'selector_template':
        this._headlineText = 'TRANS__SELECTOR__SELECT_TEMPLATE_HEADLINE';
        break;
      case 'selector_folders':
        this._headlineText = 'TRANS__CHOOSE_FOLDER';
        break;
      default:
        this._headlineText = 'TRANS__SELECT_FROM_LIST';
    }
  }

  disableSelector() {
    if (!this.selectorContainer) {
      console.error('A selector container must be set!');
    }
    this.searchSelectorService.disableSelector(this.selectorContainer);
    this.modalClosed.emit()
  }

  cancelTemplate() {
    if (this.searchContainer.selections.selectCallback) {
      this.searchContainer.selections.selectCallback(undefined);
    } else {
      console.warn('Missing select callback');
    }
  }

}
